import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Changelog.svg?component
var Changelog_exports = /* @__PURE__ */ __exportAll({
	default: () => Changelog_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
		createElementVNode("path", { d: "M12 22.125V4.712S9.545 1.985 1.268 1.875a.5.5 0 0 0-.366.15.52.52 0 0 0-.152.369v16.375a.515.515 0 0 0 .5.519C9.543 19.4 12 22.125 12 22.125" }, null, -1),
		createElementVNode("path", { d: "M9 11.18a21.3 21.3 0 0 0-5.26-1.055M9 15.375a21.3 21.3 0 0 0-5.26-1.055M15 11.18a21.3 21.3 0 0 1 5.26-1.055M15 15.375a21.3 21.3 0 0 1 5.26-1.055" }, null, -1),
		createElementVNode("path", { d: "M12 22.125V4.712s2.455-2.727 10.732-2.837a.5.5 0 0 1 .366.15.52.52 0 0 1 .152.369v16.375a.515.515 0 0 1-.5.519C14.457 19.4 12 22.125 12 22.125" }, null, -1)
	])]);
}
var Changelog_default = { render: render$1 };
//#endregion
export { Changelog_exports, Changelog_default as default, render$1 as render };

//# sourceMappingURL=Changelog.svg.virtual.js.map